<template>
	<div>
		<header>
			<h1 class="alpha heavy">Create Or Edit Fact Find</h1>
		</header>
		<div>
			<div class="sections">
				<div class="section--floating section--full">
					<the-fact-find-form cta="Save Fact Find"/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import TheFactFindForm from "./forms/TheFactFindForm.vue";

export default {
	components: {
		TheFactFindForm,
	},
};
</script>
